import { FileListHash } from "../context/UploadProvider/typesUpload";

export function countFilesAndFolders(fileList: FileListHash[]){
    let totalItens = 0;  
    function countItems(items: FileListHash[]) {
      items.forEach(item => {
        if (item.fileWorkspace) {
            totalItens++;
        }
  
        if (item.folderWorkspace) {
            totalItens++;
          countItems(item.folderWorkspace.itens);
        }
      });
    }
    countItems(fileList);
    return totalItens;
  }
